import Papa from 'papaparse';

export const countWebsites = (file) => {
    return new Promise((resolve) => {
        Papa.parse(file, {
            complete: (results) => {
                const count = results.data.filter(row =>
                    row.some(cell => cell.trim().length > 0)
                ).length - 1;
                resolve(count);
            }
        });
    });
};

export const convertToCSV = (results) => {
    const headers = ['url', 'result'];
    const rows = results.map(item =>
        headers.map(header => JSON.stringify(item[header] || '')).join(',')
    );
    return [headers.join(','), ...rows].join('\n');
};

export const downloadCSV = (csvContent) => {
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `analysis_results_${new Date().toISOString()}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
};